"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const uuid_1 = require("uuid");
const utils_1 = require("../utils");
const useInterval_1 = __importDefault(require("./useInterval"));
const store_1 = require("../store/store");
function useNodes() {
    const [nodes, setNodes] = (0, react_1.useState)([]);
    const [transferNodes, setTransferNodes] = (0, react_1.useState)([]);
    const { parameters } = (0, store_1.useParams)(state => ({
        parameters: state.parameters,
    }));
    function addNode() {
        const newNodes = new Array(parameters.GENERATE_NODE_AT_ONCE || 1)
            .fill(0)
            .map(() => ({
            id: (0, uuid_1.v4)(),
            x: Math.floor((0, utils_1.getRandom)(0, window.innerWidth)),
            y: Math.floor((0, utils_1.getRandom)(0, window.innerHeight)),
            radius: Math.floor((0, utils_1.getRandom)(parameters.MIN_RADIUS, parameters.MAX_RADIUS)),
        }));
        if (parameters.RESET_NUM <= nodes.length) {
            setNodes(prev => [prev[prev.length - 1], ...newNodes]);
            setTransferNodes([]);
        }
        else {
            setNodes(prev => [...prev, ...newNodes]);
        }
    }
    function getRandomNode() {
        const index = (0, utils_1.getRandomInteger)(0, nodes.length);
        return nodes[index];
    }
    function addTransferNode() {
        const from = getRandomNode();
        let to = getRandomNode();
        while (to.id === from.id) {
            to = getRandomNode();
        }
        const velocity = (0, utils_1.getRandomInteger)(parameters.MIN_VELOCITY, parameters.MAX_VELOCITY);
        if (from && to) {
            const distance = Math.sqrt((to.x - from.x) ** 2 + (to.y - from.y) ** 2);
            const lifeTime = Math.ceil(1000 * (distance / velocity));
            setTransferNodes(prev => [
                ...prev,
                {
                    id: (0, uuid_1.v4)(),
                    from: [from.x, from.y],
                    to: [to.x, to.y],
                    velocity,
                    lifeTime,
                },
            ]);
        }
    }
    function removeDeadTransferNode() {
        setTransferNodes(prev => {
            return prev
                .filter(node => node.lifeTime > 0)
                .map(node => (Object.assign(Object.assign({}, node), { lifeTime: node.lifeTime - 100 })));
        });
    }
    (0, useInterval_1.default)({
        callback: addTransferNode,
        delay: parameters.TIME_GENERATE_MOVING_DOTS,
    });
    (0, useInterval_1.default)({
        callback: removeDeadTransferNode,
        delay: 100,
    });
    // 어플리케이션 시작할 때 노드 생성
    (0, react_1.useEffect)(() => {
        const nums = (0, utils_1.getRandomInteger)(parameters.MIN_NUM_DOTS, parameters.MAX_NUM_DOTS);
        const newDots = new Array(nums).fill(0).map(() => ({
            id: (0, uuid_1.v4)(),
            x: (0, utils_1.getRandomInteger)(0, window.innerWidth),
            y: (0, utils_1.getRandomInteger)(0, window.innerHeight),
            radius: (0, utils_1.getRandomInteger)(parameters.MIN_RADIUS, parameters.MAX_RADIUS),
        }));
        setNodes(newDots);
    }, []);
    return {
        nodes,
        transferNodes,
        addNode,
        getRandomNode,
    };
}
exports.default = useNodes;
